import { FIELDS, INVOICE_FIELDS, CREDIT_FIELDS } from './constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  // {
  //   field: 'selectcommands',
  //   title: ' ',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyId',
    field: FIELDS.COMPANY_ID,
    title: ' Company Id',
    label: 'CompanyId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Customer',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PaymentDate',
    field: FIELDS.PAYMENT_DATE,
    title: ' Payment Date',
    label: 'PaymentDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PaymentMethodId',
    field: FIELDS.PAYMENT_METHOD_ID,
    title: ' Payment Method Id',
    label: 'PaymentMethodId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PaymentMethodName',
    field: FIELDS.PAYMENT_METHOD_NAME,
    title: ' Payment Method',
    label: 'PaymentMethodName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReferenceNumber',
    field: FIELDS.REFERENCE_NUMBER,
    title: ' Reference Number',
    label: 'ReferenceNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Amount',
    field: FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export const InvoiceDefaultFields =  [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'invoiceNo',
    cell: 'navigation',
    field: INVOICE_FIELDS.INVOICE_NO,
    title: 'Invoice No',
    label: 'Invoice No',
    sortable: true,
    hidden: false,
    locked: false,
    width: 100,
  },
  {
    key: 'company',
    field: INVOICE_FIELDS.COMPANY_NAME,
    title: 'Company Name',
    label: 'Company Name',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'invoiceDate',
    cell: 'invoiceDate',
    field: INVOICE_FIELDS.INVOICE_DATE,
    title: 'Invoice Date',
    label: 'Invoice Date',
    sortable: true,
    hidden: false,
    width: 120,
  },
  {
    key: 'customerPO',
    field: INVOICE_FIELDS.CUSTOMER_PO,
    title: 'Customer Purchase Order',
    label: 'Customer Purchase Order',
    sortable: true,
    hidden: false,
    width: 80,
  },
  {
    key: 'salesOrderId',
    field: INVOICE_FIELDS.SALES_ORDER_ID,
    title: 'Sales Order Id',
    label: 'Sales Order Id',
    sortable: true,
    hidden: true,
    width: 80,
  },
  {
    field: INVOICE_FIELDS.QUANTITY,
    title: 'Qty',
    label: 'Qty',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    field: INVOICE_FIELDS.PREFIX,
    title: 'Prefix',
    label: 'Prefix',
    sortable: true,
    hidden: true,
    width: 50,
  },
  {
    field: INVOICE_FIELDS.PART_NUMBER,
    title: 'Part Number',
    label: 'Part Number',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    field: INVOICE_FIELDS.CUSTOMER_PART_NUMBER,
    title: 'Customer PN',
    label: 'Customer PN',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    field: INVOICE_FIELDS.DESCRIPTION,
    title: 'Description',
    label: 'Description',
    sortable: true,
    hidden: true,
    width: 400,
  },
  {
    field: INVOICE_FIELDS.MANUFACTURER,
    title: 'Mfr',
    label: 'Mfr',
    sortable: true,
    hidden: true,
    width: 300,
  },
  {
    field: INVOICE_FIELDS.ALTERNATE_NUMBER,
    title: 'Alternate PN',
    label: 'Alternate PN',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    field: INVOICE_FIELDS.INTERNAL_NUMBER,
    title: 'Internal PN',
    label: 'Internal PN',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    field: INVOICE_FIELDS.DATE_CODE,
    title: 'Date Code',
    label: 'Date Code',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: INVOICE_FIELDS.LOT_CODE,
    title: 'Lot Code',
    label: 'Lot Code',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: INVOICE_FIELDS.COST,
    title: 'Cost',
    label: 'Cost',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    field: INVOICE_FIELDS.PRICE,
    title: 'Price',
    label: 'Price',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    field: INVOICE_FIELDS.TOTAL,
    title: 'Total',
    cell:'total',
    label: 'Total',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    field: INVOICE_FIELDS.BALANCE,
    title: 'Balance',
    cell:'balance',
    label: 'Balance',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'salesRep',
    field: INVOICE_FIELDS.SALES_REP,
    title: 'Sales Rep',
    label: 'Sales Rep',
    sortable: true,
    hidden: true,
    width: 125,
  },
  {
    field: INVOICE_FIELDS.PIECES_PER_PACKAGE,
    title: 'Pcs/Pkg',
    label: 'Pcs/Pkg',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    field: INVOICE_FIELDS.PHYSICAL_PACKAGE,
    title: 'Phys Pkg',
    label: 'Phys Pkg',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    field: INVOICE_FIELDS.PACKAGE,
    title: 'Pkg',
    label: 'Pkg',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    field: INVOICE_FIELDS.CONDITION,
    title: 'Condition',
    label: 'Condition',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    field: INVOICE_FIELDS.TEMPERATURE_RATING,
    title: 'Temp Rating',
    label: 'Temp Rating',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    field: INVOICE_FIELDS.COMMENTS,
    title: 'Comments',
    label: 'Comments',
    sortable: true,
    hidden: true,
    width: 200,
  },
  {
    key: 'shipDate',
    field: INVOICE_FIELDS.SHIP_DATE,
    title: 'Ship Date',
    label: 'Ship Date',
    sortable: true,
    hidden: true,
    width: 120,
  },
  {
    key: 'salesOrderNumber',
    field: INVOICE_FIELDS.SALES_ORDER_NUMBER,
    title: 'Sales Order Number',
    label: 'Sales Order Number',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'contact',
    field: INVOICE_FIELDS.CONTACT,
    title: 'Contact',
    label: 'Contact',
    sortable: true,
    hidden: true,
    width: 125,
  },
  {
    key: 'shippedBy',
    field: INVOICE_FIELDS.SHIPPED_BY,
    title: 'Shipped By',
    label: 'Shipped By',
    sortable: true,
    hidden: true,
    width: 125,
  },
  {
    key: 'terms',
    field: INVOICE_FIELDS.TERMS,
    title: 'Terms',
    label: 'Terms',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'subTotal',
    field: INVOICE_FIELDS.SUB_TOTAL,
    title: 'Subtotal',
    label: 'Subtotal',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'shippingCharge',
    field: INVOICE_FIELDS.SHIPPING_CHARGE,
    title: 'Ship Chrg',
    label: 'Ship Chrg',
    sortable: true,
    hidden: true,
    width: 100,
  },
  {
    key: 'shipVia',
    field: INVOICE_FIELDS.SHIP_VIA,
    title: 'Ship Via',
    label: 'Ship Via',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'trackingNumber',
    field: INVOICE_FIELDS.TRACKING_NUMBER,
    title: 'Tracking No',
    label: 'Tracking No',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'dateCreated',
    field: INVOICE_FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: true,
    width: 120,
  },
  {
    key: 'dateModified',
    field: INVOICE_FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'Date Modified',
    sortable: true,
    hidden: true,
    width: 120,
  },
  {
    key: 'active',
    field: INVOICE_FIELDS.ACTIVE,
    title: 'Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 50,
  },
  // {
  //   key: 'id',
  //   field: INVOICE_FIELDS.ID,
  //   title: 'Id',
  //   label: 'id',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'amount',
    field: 'editamount',
    title: 'Amount',
    label: 'Amount',
    cell: 'editamount',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'creditPayment',
    field: 'creditPayment',
    title: 'Credit',
    label: 'Credit',
    cell: 'creditPayment',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'totalAmount',
    field: 'totalAmount',
    title: 'Total Applied',
    label: 'Total Applied',
    cell: 'totalAmount',
    sortable: true,
    hidden: false,
    width: 100,
  },
]

export const creditFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'Id',
    field: CREDIT_FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'dateCreated',
    field: CREDIT_FIELDS.CREDIT_DATE,
    title: ' Credit Date',
    label: 'dateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'salesOrderId',
    field: CREDIT_FIELDS.SO_NO,
    title: ' Sales Order Id',
    label: 'salesOrderId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Amount',
    field: CREDIT_FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Balance',
    field: CREDIT_FIELDS.BALANCE,
    title: ' Balance',
    label: 'Balance',
    cell: 'balance',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'payment',
    field: 'payment',
    title: 'Payment',
    label: 'Payment',
    cell: 'editPayment',
    sortable: true,
    hidden: false,
    width: 100,
  },
]

export default defaultFields;
